<div class="d-flex h-100 card">
  <div class="mx-auto my-auto">
    <img style="height:50px" src="assets/images/chart-loading.svg" class="loading-spinner" />
  </div>
</div>
